import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import { sizePerPageList,formatDate } from "../../../utility";

export const RhheaderTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
}) => {
  
  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "Rayon Code",
      dataField: "rayonCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Plant",
      dataField: "plant",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Rayon type",
      dataField: "rayonType",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "BUM",
      dataField: "BUM",
      sortCaret: sortCaret,
      sort: true,

      headerSortingClasses,
    },
    {
      text: "NSM",
      dataField: "NSM",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "ASM",
      dataField: "ASM",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "FSS",
      dataField: "FSS",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "SLM",
      dataField: "SLM",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Valid From",
      dataField: "validFrom",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
    {
      text: "Valid To",
      dataField: "validTo",
      sort: true,

      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  return (
    <BootstrapTable
      remote
      wrapperClasses="table-responsive"
      classes="table table-head-custom table-vertical-center overflow-hidden"
      bootstrap4
      bordered={false}
      keyField="kacab_id"
      data={data === null ? [] : data}
      columns={columns}
      pagination={paginationFactory(options)}
      onTableChange={onTableChange}
    >
      <PleaseWaitMessage entities={loading ? null : data} />
      <NoRecordsFoundMessage entities={loading ? null : data} />
    </BootstrapTable>
  );
};
